
import { CONSTANTS } from "../../constants";

export default {
  name: "TMSPage",
  data: () => ({
    BANNER_DETAILS: CONSTANTS.TMS_BANNER_DETAILS,
    CLIENTS: ["Janta Transport", "Janta Roadways"],
    REVIEWS: CONSTANTS.REVIEWS,
    features: [
      {
        name: "Easy to Use and Customizable",
        description: [
          {
            title: "User-Friendly Interface",
            data: "Experience an intuitive and easy-to-navigate UI designed to minimise the learning curve, ensuring quick adoption by your team.",
          },
          {
            title: "Customisable Workflows",
            data: "Tailor the system to match your specific business processes, enhancing operational efficiency.",
          },
          {
            title: "Flexible Configuration",
            data: "Adapt the system's features and functionalities to meet the evolving demands of your transport business.",
          },
        ],
        imageName: "/tms/tms1.png",
      },
      {
        name: "Role Based Access",
        description: [
          {
            title: "Secure Access Control",
            data: "Assign role-based permissions to ensure users only access relevant information and functionalities.",
          },
          {
            title: "User-Specific Views",
            data: "Provide personalized views and dashboards for different user roles, enhancing user productivity.",
          },
          {
            title: "Password Management",
            data: "Enable secure password resets and forgotten password retrieval options for enhanced security and convenience.",
          },
        ],
        imageName: "/tms/tms2.png",
      },
      {
        name: "Control Your Data",
        description: [
          {
            title: "Comprehensive Entry Module",
            data: "Add and manage locations, warehouses, vehicles, and renewal categories seamlessly.",
          },
          {
            title: "Consigner and Consignee Management",
            data: "Keep track of all your consigners and consignees in one centralized location.",
          },
          {
            title: "Data Integrity",
            data: "Ensure accurate and up-to-date information for all entities in your transport operations.",
          },
        ],
        imageName: "/tms/tms3.png",
      },
      {
        name: "Track and Update Vehicle Renewals",
        description: [
          {
            title: "Renewal Management",
            data: "Categorize and manage vehicle renewals efficiently from the entry module.",
          },
          {
            title: "Timely Alerts",
            data: "Receive notifications for upcoming renewals to avoid compliance issues and downtime.",
          },
          {
            title: "Renewal History",
            data: " Maintain a detailed history of all past renewals for audit and compliance purposes.",
          },
        ],
        imageName: "/tms/tms4.png",
      },
      {
        name: "Consignments, Manifests, Bills, and Payment Updates",
        description: [
          {
            title: "Consignment Tracking",
            data: "Monitor shipments from consigner to consignee with real-time updates.",
          },
          {
            title: "Manifest Management",
            data: "Manage multiple consignments under a single manifest for streamlined deliveries.",
          },
          {
            title: "Billing",
            data: " Generate invoices for consignees, supporting monthly billing cycles.",
          },
          {
            title: "Payment Tracking",
            data: "Update payment statuses for consignments paid through offline methods, ensuring accurate revenue tracking.",
          },
        ],
        imageName: "/tms/tms5.png",
      },
      {
        name: "Reports and Analytics",
        description: [
          {
            title: "Detailed Reporting",
            data: "Generate comprehensive reports on consignments, manifests, bills, and payments.",
          },
          {
            title: "Actionable Insights",
            data: "Leverage accurate analytics to understand volume processed and revenue generated.",
          },
          {
            title: "Custom Reports",
            data: "Create customized reports to meet specific business requirements and decision-making needs.",
          },
        ],
        imageName: "/tms/tms6.png",
      },
      {
        name: "Miscellaneous Features",
        description: [
          {
            title: "Activity Logs",
            data: "View content updates by date, tracking changes made by employees.",
          },
          {
            title: "Dynamic Filtering",
            data: "Filter data on the go in various views for quick access to relevant information.",
          },
          {
            title: "Data Export",
            data: "Export data to PDF and Excel formats for easy sharing and analysis.",
          },
          {
            title: "Email Functionality",
            data: "Send emails directly from the system, enhancing communication with stakeholders.",
          },
        ],
        imageName: "/tms/tms7.png",
      },
    ],
  }),
  head() {
    return {
      title: "Transport Management System by AiBuddha",
      description: "Optimise your Transport Operations with Transport Management System built by AiBuddha",
    };
  },
};
